import { Button, ButtonTypeMap } from '@mui/material';
import { useState } from 'react';
import styles from './OpenModalButton.module.scss';

export interface DefaultOpenModalProps {
    modalOpen: boolean;
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface OpenModalButtonProps {
    icon: React.ReactNode;
    modal: ({ modalOpen, setModalOpen }: DefaultOpenModalProps) => JSX.Element;
    size?: ButtonTypeMap['props']['size'];
    testId?: string;
    className?: string;
    children: React.ReactNode;
    modalProps?: any;
    disabled?: boolean;
}

/**
 * specialized button to open modals
 * @param icon - icon to prefix the button text
 * @param modal - modal to open
 * @param size - size of button
 * @param testId - test id field
 * @param className - additional styling className
 * @param children - button test/children
 * @param disabled - is the button disabled
 * @returns OpenModalButton
 */
export function OpenModalButton({
    icon,
    size = 'medium',
    testId,
    modal,
    children,
    className,
    modalProps,
    disabled,
}: OpenModalButtonProps) {
    const [modalOpen, setModalOpen] = useState(false);
    const Modal = modal;

    const handleModalToggle = () => setModalOpen(!modalOpen);

    return (
        <>
            <Button
                startIcon={icon}
                onClick={handleModalToggle}
                data-testid={`{${testId}-open-modal-button`}
                size={size}
                className={className}
                disabled={disabled}
            >
                {children}
            </Button>
            {modalOpen && (
                <div className={styles['modal-container']}>
                    <Modal
                        modalOpen={modalOpen}
                        setModalOpen={setModalOpen}
                        {...modalProps}
                    />
                </div>
            )}
        </>
    );
}
